import React from 'react';
import useLogout from './hooks/useLogout';
import Box from 'v2/components/UI/Box';
import HashLoading from 'v2/components/UI/Loading/Hash';
import Text from 'v2/components/UI/Text';

const Logout: React.FC = () => {
  useLogout();
  return (
    <Box
      position="fixed"
      top={0}
      bottom={0}
      left={0}
      width={'100%'}
      height={'100%'}
      background={' #dbffde'}
      alignItems={'center'}
      justifyContent={'center'}
      zIndex={999999999}
      flexDirection="column"
      gap={10}
    >
      <HashLoading size={60} />
      <Text fontSize={26} fontWeight={600} color="#1b1b1b">
        Saindo da sua conta...
      </Text>
    </Box>
  );
};

export default Logout;
